/* ============
 * Counterparty Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    addedAdresses: [],
    counterpartyTypes: [],
    counterpartyAddressTypes: [],
    counterparties: [],
    counterpartiesHistory: [],
    directoryLegalForms: [],
    currentCounterpartyIdInDB: null,
    selectedAddressTypes: [],
    counterpartiesForContract: [],
  },
  actions,
  getters,
  mutations
};
